const tabs_header = document.querySelectorAll('.tabs_header button');
const tabs_content = document.querySelectorAll('.tab_content');

const tabs_header_arr = Array.from(tabs_header);
const tabs_content_arr = Array.from(tabs_content);

tabs_header_arr.map(function(tab_header) {

    
    tab_header.addEventListener('click', function() {
            clearActive();
            tab_header.classList.add('active');
            const target = tab_header.getAttribute('data-target');
            document.querySelector(`#tab-${target}`).classList.add('active');
    });

});

function clearActive() {
    tabs_header_arr.map(function(item) {
        removeActive(item);
    });

    tabs_content_arr.map(function(item) {
        removeActive(item);
    });
}

function removeActive(item) {
    item.classList.remove('active');
}